import { useState, useMemo } from "react"
import { useQuery } from "@tanstack/react-query"
// hooks
import useDownloadCertificate from "pages/Test/hooks/useDownloadCertificate"
import useDownloadExternalCertificate from "pages/Test/hooks/useDownloadExternalCertificate"
import useExternalCertificateCheckoutModal from "pages/Test/hooks/useExternalCertificateCheckoutModal"
// api
import {
  EXTERNAL_CERTIFICATE_PROGRESS_KEYS,
  getExternalCertificateProgresses,
  GetExternalCertificateProgressesResponse,
  ExternalCertificatePaymentStatus,
} from "api"

const usePassedCmeTests = (): {
  handleDownloadCertificate: (superCourseId: number) => void
  cmeCertificateLoading: boolean
  externalCertificateStatusBySuperCourseId: Record<number, ExternalCertificatePaymentStatus>
  handleDownloadExternalCertificate: (superCourseId: number) => void
  externalCertificateLoading: boolean
  handleOpenExternalCertificateCheckout: (superCourseId: number) => void
} => {
  const [currentCupperCourseId, setCurrentCupperCourse] = useState(0)

  const { cmeCertificateLoading } = useDownloadCertificate({
    superCourseId: currentCupperCourseId,
    autoFetchEnabled: true,
  })

  const { fetchExternalCertificate, externalCertificateLoading } = useDownloadExternalCertificate()

  const { handleOpenExternalCertificateCheckout } = useExternalCertificateCheckoutModal()

  const { data: externalCertificateProgresses } = useQuery<GetExternalCertificateProgressesResponse>({
    queryKey: [EXTERNAL_CERTIFICATE_PROGRESS_KEYS.GET_EXTERNAL_CERTIFICATE_PROGRESSES],
    queryFn: getExternalCertificateProgresses,
  })

  const externalCertificateStatusBySuperCourseId = useMemo(() => {
    const statusBySuperCourseId: Record<number, ExternalCertificatePaymentStatus> = {}

    externalCertificateProgresses?.data.forEach(({ paymentStatus, super_course }) => {
      statusBySuperCourseId[super_course.id] = paymentStatus
    })

    return statusBySuperCourseId
  }, [externalCertificateProgresses])

  return {
    handleDownloadCertificate: setCurrentCupperCourse,
    cmeCertificateLoading,
    externalCertificateStatusBySuperCourseId,
    handleDownloadExternalCertificate: fetchExternalCertificate,
    externalCertificateLoading,
    handleOpenExternalCertificateCheckout,
  }
}

export default usePassedCmeTests
